import { Controller } from "stimulus";
import { SearchItemContainer } from '../search/search_item_container';
import { searchFormHelpers } from '../search/search_form_helpers';
import { searchFormFlex } from '../listings/search_form_flex';
import {
  normalizeListingIdsFromExpandedString,
  mlsResolutionSignatureForHiddenContainer
} from './mls_number_input_helpers';

const MAX_RANGE_SIZE = 200;

export default class extends Controller {
  static targets = ["input", "hiddenContainer"]

  connect() {
    this._resolving = false;
    if (!this.hasInputTarget) {
      return;
    }
    const $card = $(this.element);
    // After flexCardGroup/searchForm init (same AJAX tick), expand and focus like other filter cards.
    setTimeout(() => {
      SearchItemContainer.expandContainer($card);
      SearchItemContainer.setContainerFocus($card, false);
    }, 0);
  }

  handleKeydown(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      this.inputChanged();
    }
  }

  inputChanged() {
    if (this._resolving) return;

    const $card = $(this.element);
    const rawValue = this.inputTarget.value.trim();

    if (rawValue.length === 0) {
      const prevSig = this._mlsResolutionSignature();
      const prevSummary = this._cardSummaryText($card);
      this._clearMlsHiddenFields();
      SearchItemContainer.updateContainerSummaryText($card, '');
      SearchItemContainer.checkContainer($card, false);
      if (prevSig !== '' || prevSummary !== '') {
        this._triggerFormReload();
      }
      return;
    }

    const expandedValue = this._expandRanges(rawValue);
    this._resolveMlsNumbers(expandedValue, rawValue);
  }

  _resolveMlsNumbers(expandedIds, displayValue) {
    this._resolving = true;

    const data = { listing_ids: expandedIds };

    const mlsIdSelect = document.querySelector('#search_fields_MlsId_value');
    if (mlsIdSelect) {
      const selectedValues = $(mlsIdSelect).val();
      if (selectedValues && selectedValues.length > 0) {
        data.mls_id = selectedValues;
      }
    }

    $.ajax({
      url: routes.resolve_mls_numbers_path(),
      type: 'POST',
      data: data,
      success: (response) => {
        this._resolving = false;
        const listings = response.listings || [];

        const $card = $(this.element);
        const prevSig = this._mlsResolutionSignature();
        const prevSummary = this._cardSummaryText($card);
        const displayTrimmed = displayValue.trim();

        this._clearMlsHiddenFields();

        if (listings.length > 0) {
          listings.forEach((listing) => {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'search_fields[ListingKey][value][]';
            hidden.value = listing.listing_key;
            this.hiddenContainerTarget.appendChild(hidden);
          });

          SearchItemContainer.checkContainer($card, true);
        } else {
          const tokens = normalizeListingIdsFromExpandedString(expandedIds);
          if (tokens.length > 0) {
            tokens.forEach((token) => {
              const hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'search_fields[ListingId][value][]';
              hidden.value = token;
              this.hiddenContainerTarget.appendChild(hidden);
            });

            SearchItemContainer.checkContainer($card, true);
          }
        }

        SearchItemContainer.updateContainerSummaryText($card, displayValue);

        const newSig = this._mlsResolutionSignature();
        const sigChanged = prevSig !== newSig;
        const displayChanged = prevSummary !== displayTrimmed;
        if (sigChanged || displayChanged) {
          this._triggerFormReload();
        }
      },
      error: () => {
        this._resolving = false;
      }
    });
  }

  _clearMlsHiddenFields() {
    this.hiddenContainerTarget.innerHTML = '';
  }

  _mlsResolutionSignature() {
    return mlsResolutionSignatureForHiddenContainer(this.hiddenContainerTarget);
  }

  _cardSummaryText($card) {
    return $card.find('.c-card-enable-summary').text().trim();
  }

  _triggerFormReload() {
    const serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, false);
  }

  _expandRanges(input) {
    const parts = input.split(/\s*,\s*/);
    const expanded = [];

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part === '') continue;

      const rangeMatch = part.match(/^(.*?)(\d+)\.\.(.*?)(\d+)$/);
      if (rangeMatch) {
        let prefixA = rangeMatch[1];
        let prefixB = rangeMatch[3];

        if (prefixB === '') {
          prefixB = prefixA;
        }
        if (prefixA !== prefixB) {
          expanded.push(part);
          continue;
        }

        const startStr = rangeMatch[2];
        const padLength = startStr.length;
        let start = parseInt(startStr, 10);
        let end = parseInt(rangeMatch[4], 10);
        if (start > end) {
          const tmp = start;
          start = end;
          end = tmp;
        }
        if ((end - start) > MAX_RANGE_SIZE) {
          end = start + MAX_RANGE_SIZE;
        }
        for (let n = start; n <= end; n++) {
          if (expanded.length >= MAX_RANGE_SIZE) break;
          expanded.push(prefixA + String(n).padStart(padLength, '0'));
        }
      } else {
        expanded.push(part);
      }
      if (expanded.length >= MAX_RANGE_SIZE) break;
    }

    return expanded.join(',');
  }
}
